import * as React from 'react';

export const traverseChildren = (item, callback) => {
  const exitEarly = callback(item);
  const hasChildren = Boolean(item && item.props && item.props.children);
  if (!exitEarly && hasChildren) {
    React.Children.forEach(item.props.children, child => traverseChildren(child, callback));
  }
};
